module.exports = __webpack_public_path__ + "img/private-files.e37b6fd7.png";